module.exports = __webpack_public_path__ + "img/9788930315388.7f2fbd48.jpg";